import flatten from 'lodash/flatten';

import { Component, ElementRef, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';

export interface ITab {
  key: string;
  text: string;
  infoBadge?: string | number;
}

@Component({
  selector: 'grouped-tabset',
  templateUrl: './grouped-tabset.component.html',
  styleUrls: ['./grouped-tabset.component.scss'],
})
export class GroupedTabsetComponent {
  @Input() public set tabGroups(tabGroups: ITab[][]) {
    this.tabGroupsInternal = tabGroups;
    this.selectedTabKey = this.selectedTabKey ||
      (tabGroups.length > 0 && tabGroups[0].length > 0 ? flatten(tabGroups)[0].key : '');
    this.renderCyclesUntilNextDividerCheck = 1;
  }
  @Input() public selectedTabKey: string = '';
  @Output() public selectedTabKeyChange: EventEmitter<string> = new EventEmitter();

  public tabGroupsInternal: ITab[][] = [];
  public get selectedTabIndex(): number {
    return flatten(this.tabGroupsInternal).findIndex((tab: ITab) => tab.key === this.selectedTabKey);
  }

  @ViewChild('sampleDivider', { static: true }) private sampleDivider: TemplateRef<any>;
  private renderCyclesUntilNextDividerCheck: number = -1;

  constructor(private elRef: ElementRef) { }

  public ngAfterViewChecked(): void {
    if (this.renderCyclesUntilNextDividerCheck === 0) {
      this.renderCyclesUntilNextDividerCheck = -1;
      this.updateGroupDividers();
    } else if (this.renderCyclesUntilNextDividerCheck > 0) {
      this.renderCyclesUntilNextDividerCheck--;
    }
  }

  public onTabClick(key: string): void {
    this.selectedTabKeyChange.emit(key);
  }

  private updateGroupDividers(): void {
    const existingClones: HTMLElement[] = Array.from(this.elRef.nativeElement.querySelectorAll('.cloned-divider'));
    existingClones.forEach((elem: HTMLElement) => elem.remove());

    const tabGroupStarts: HTMLElement[] = Array.from(this.elRef.nativeElement.querySelectorAll('.tab-group-start'))
      .map((elem: HTMLElement) => elem.parentNode as HTMLElement);
    tabGroupStarts.forEach((elem: HTMLElement) => {
      const clonedNode: HTMLElement = this.sampleDivider.elementRef.nativeElement.cloneNode();
      clonedNode.classList.remove('d-none-imp');
      clonedNode.classList.add('cloned-divider');
      elem.parentElement.insertBefore(clonedNode, elem);
    });
  }
}
